import styled from 'styled-components';
import { media } from '../../ui/helpers';

const ImageWrapper = styled.div<{
  ratio: number;
  secondaryRatio?: number;
  bg?: string;
}>`
  position: relative;
  overflow: hidden;

  &::after {
    display: block;
    content: '';
    padding-bottom: ${({ ratio }) => `${100 / ratio}%`};
  }

  img {
    position: absolute;
    width: 100%;
    height: 100%;
    top: 0;
    left: 0;
    margin: auto;
  }

  .bg {
    background: ${({ bg }) => `url(${bg}) no-repeat center center`};
    background-size: cover;
    width: 100%;
    height: 100%;
    overflow: hidden;
    position: absolute;
  }

  ${media.min('medium')`
    &::after {
      padding-bottom: ${({ secondaryRatio, ratio }) =>
        secondaryRatio ? `${100 / secondaryRatio}%` : `${100 / ratio}%`};
    }
  `};
`;

export { ImageWrapper };
